import React from 'react';
import ToolTip from './ToolTip';

interface InputLabelProps {
  label: string;
  tooltipMessage?: string;
  astric?: boolean;
  disabled?: boolean;
}

const InputLabel: React.FC<InputLabelProps> = ({ label, tooltipMessage, astric, disabled }) => {
  return (
    <div className={`label flex h-5 items-center ${disabled ? 'text-gray-600' : ''}`}>
      <p className="text-sm font-bold text-[#484848]">{label}</p>
      {astric ? <span className="text-sm font-bold text-[#484848]">&nbsp;*</span> : null}
      <div className="tooltip ml-1">{tooltipMessage ? <ToolTip iconName="info" message={tooltipMessage} /> : null}</div>
    </div>
  );
};

export default InputLabel;
